module.exports = __webpack_public_path__ + "img/Local Bee orange.10156ec4.svg";